<template>
    <b-overlay :show="busy" rounded="sm">
        <!-- {{type}} -->
        <!-- {{ value }} -->
        <!-- {{ lines }} -->
        <b-card class="standardpage border-none ">

            <div class="mt-2 availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0 px-0">

                        <b-overlay opacity="0.3" :show="allocateonly == true">
                            <template #overlay>
                                <b-icon icon=""></b-icon>
                            </template>
                            <p>

                                <b-row class="">
                                    <b-col>
                                        <b-tabs class="gridtabs" v-model="payindex">
                                            <b-tab>
                                                <template #title>
                                                    <div class="badgecontainer pr-2 mr-1">
                                                        <i class="fa fa-gbp mr-1"></i>
                                                        Receipt
                                                    </div>
                                                </template>
                                                <b-row>
                                                    <b-col>
                                                        <b-alert :show="true" variant="secondary" class="mb-2">
                                                            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                                    <i
                                                                        class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                                <b-col>
                                                                    <span class="h6"> Post a cash receipt/payment to the
                                                                        Sales Ledger
                                                                        on account. Enter
                                                                        the total amount you are posting and optionally
                                                                        break down the payment
                                                                        by SL A/C (required) and event to match the
                                                                        total.
                                                                    </span></b-col></b-row>
                                                        </b-alert></b-col>
                                                </b-row>

                                                <b-row class="">

                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label-cols="12" label="Receipt Amount"
                                                            label-size="sm">
                                                            <b-input-group>
                                                                <b-form-input v-model="amount" :disabled="false"
                                                                    :debounce="500" placeholder="Receipt Amount"
                                                                    trim></b-form-input>
                                                                <b-input-group-append>
                                                                    <b-button size="sm" variant="outline-secondary"
                                                                        @click="amount = ''" :disabled="false">
                                                                        <i class="fa fa-remove"></i>
                                                                    </b-button>
                                                                </b-input-group-append>
                                                            </b-input-group>
                                                        </b-form-group>
                                                    </b-col>

                                                    <!-- <b-col class="pt-1 pl-3 strong h6">Must match money GBP {{
                                                        Math.abs(amount).toFixed(2)
                                                    }}
                                                    </b-col> -->
                                                    <b-col v-if="difference" class="pt-4 strong h6 text-right pr-4"
                                                        :class="parseFloat(difference) == 0 ? 'text-primary' : 'text-danger'">Total
                                                        is
                                                        out by
                                                        GBP
                                                        {{
                                                            parseFloat(difference).toFixed(2) }}</b-col>

                                                </b-row>

                                                <b-row class="mt-2 px-3">
                                                    <!-- {{ sl_lines }} -->

                                                    <div
                                                        class="mt-0 mb-1 text-center nested availtable datatable smallinputs etable">
                                                        <table
                                                            class="w-100pct table b-table table-striped table-hover table-sm mb-1"
                                                            style="table-layout:fixed">
                                                            <!-- <tr class="header-dark"> -->
                                                            <tr class="header-primary text-white">

                                                                <td colspan="2" class="text-center w-30px">Lines </td>

                                                                <td class="text-center w-35px"
                                                                    v-if="columns.includes('prefix')">
                                                                    Type
                                                                </td>

                                                                <td class="text-right w-100px"
                                                                    v-if="columns.includes('description')">
                                                                    Description
                                                                </td>

                                                                <td class="text-center w-80px"
                                                                    v-if="columns.includes('slac')">
                                                                    SL A/C
                                                                </td>

                                                                <td class="text-center w-80px"
                                                                    v-if="columns.includes('eventcode')">
                                                                    Event
                                                                </td>

                                                                <td class="text-center w-110px"
                                                                    v-if="columns.includes('nlcode')">
                                                                    NL Code
                                                                </td>

                                                                <td class="text-center w-50px"
                                                                    v-if="columns.includes('amount')">
                                                                    Received
                                                                </td>

                                                                <td role="columnheader" scope="col" aria-colindex="1"
                                                                    class="table-b-table-default text-center w-25px">
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td></td>
                                                                <td colspan="5"></td>
                                                            </tr>
                                                            <tbody role="rowgroup">
                                                                <tr v-for="(line, index) in lines" :key="index">

                                                                    <td class="">
                                                                        <span class="small text-primary">{{ index + 1
                                                                            }}.</span>
                                                                    </td>
                                                                    <td class="">
                                                                        <!-- <i :class="line.icon" class="mr-2"></i> -->
                                                                        <i class="fa fa-handshake-o"></i>
                                                                    </td>

                                                                    <td v-if="columns.includes('prefix')">
                                                                        <b-form-group class="">
                                                                            <b-input-group>
                                                                                <treeselect instanceId="type"
                                                                                    v-model="line.prefix"
                                                                                    :clearable="true"
                                                                                    :options="prefix_options"
                                                                                    :multiple="false" class="h-20px"
                                                                                    @select="edited = true">
                                                                                </treeselect>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </td>

                                                                    <td v-if="columns.includes('description')">
                                                                        <b-form-group class="mb-3px">
                                                                            <b-input-group>
                                                                                <b-form-input size="sm"
                                                                                    v-model="line.description"
                                                                                    placeholder="Description"
                                                                                    class="text-left"></b-form-input>
                                                                                <b-input-group-append>
                                                                                    <b-button size="sm"
                                                                                        variant="outline-secondary"
                                                                                        @click="line.description = ''"
                                                                                        :disabled="line.description == ''">
                                                                                        <i class="fa fa-remove"></i>
                                                                                    </b-button>
                                                                                </b-input-group-append>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </td>

                                                                    <td v-if="columns.includes('slac')">
                                                                        <b-form-group class="">
                                                                            <b-input-group>
                                                                                <treeselect placeholder="Select slac..."
                                                                                    searchPromptText="Type at least 3 chars..."
                                                                                    v-model="line.slac"
                                                                                    :clearable="true" :multiple="false"
                                                                                    :async="true"
                                                                                    :load-options="treeselect_loadSLAC"
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" search-nested
                                                                                    :disabled="readonly" class="h-20px"
                                                                                    @select="edited = true">
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </td>
                                                                    <td v-if="columns.includes('eventcode')">
                                                                        <b-form-group class="">
                                                                            <b-input-group>
                                                                                <treeselect
                                                                                    placeholder="Select event..."
                                                                                    v-model="line.eventcode"
                                                                                    :clearable="true" :async="true"
                                                                                    :load-options="treeselect_loadEvent"
                                                                                    searchPromptText="Type at least 4 chars..."
                                                                                    :show-count="true"
                                                                                    :flatten-search-results="true"
                                                                                    :disable-branch-nodes="true"
                                                                                    :matchKeys="['id']" search-nested
                                                                                    class="h-20px"
                                                                                    @select="edited = true">
                                                                                    <div slot="value-label"
                                                                                        slot-scope="{ node }">
                                                                                        {{ node.raw.id }}
                                                                                    </div>
                                                                                </treeselect>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </td>

                                                                    <td v-if="columns.includes('nlcode')">
                                                                        <b-form-group class="">
                                                                            <b-input-group>
                                                                                <treeselect instanceId="nlcode"
                                                                                    v-model="line.nlcode"
                                                                                    :clearable="true"
                                                                                    :disabled="index == 0"
                                                                                    :options="nlcode_options"
                                                                                    :multiple="false" class="h-20px"
                                                                                    @select="edited = true">
                                                                                </treeselect>
                                                                            </b-input-group>
                                                                        </b-form-group>
                                                                    </td>

                                                                    <td v-if="columns.includes('amount')">
                                                                        <b-form-group class="mb-3px">
                                                                            <b-input-group>
                                                                                <b-form-input size="sm"
                                                                                    v-model="line.amount"
                                                                                    placeholder="Amount"
                                                                                    class="text-right"
                                                                                    :formatter="nocomma"></b-form-input>
                                                                                <b-input-group-append>
                                                                                    <b-button size="sm"
                                                                                        variant="outline-secondary"
                                                                                        @click="line.amount = '0.00'"
                                                                                        :disabled="line.amount == '0.00'">
                                                                                        <i class="fa fa-remove"></i>
                                                                                    </b-button>
                                                                                </b-input-group-append>
                                                                            </b-input-group>

                                                                        </b-form-group>
                                                                    </td>

                                                                    <td :id="'lines-del_' + index" class="w-30px"
                                                                        style="padding-left:5px !important;">
                                                                        <b-input-group v-if="index > 0"
                                                                            class="m-auto w-15px">
                                                                            <i class="fa fa-trash text-danger font-14px"
                                                                                @click="delLine(index + 1)"></i>
                                                                            <b-tooltip :target="'lines-del_' + index"
                                                                                placement="top">Del
                                                                                line</b-tooltip>

                                                                        </b-input-group>

                                                                        <!-- <b-input-group v-if="line.prefix"
                                                                        class="m-auto w-15px">
                                                                        <i class="fa fa-trash text-danger font-14px"
                                                                            @click="delLine(index + 1)"></i>
                                                                        <b-tooltip :target="'lines-del_' + index"
                                                                            placement="top">Del
                                                                            line</b-tooltip>

                                                                    </b-input-group> -->
                                                                    </td>

                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                        <b-row class="mt-1 text-left">
                                                            <b-col style="margin-left:10px">
                                                                <i class="fa fa-plus-square-o text-primary font-20px"
                                                                    @click="addLine"></i>
                                                            </b-col>
                                                        </b-row>

                                                    </div>

                                                </b-row>
                                            </b-tab>
                                            <b-tab>
                                                <template #title>
                                                    <div class="badgecontainer pr-2 mr-1">
                                                        <i class="fa fa-table mr-1"></i>
                                                        Payments
                                                    </div>
                                                </template>

                                                <b-row>
                                                    <b-col>
                                                        <b-alert :show="true" variant="secondary" class="mb-2">
                                                            <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                                    <i
                                                                        class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                                <b-col>
                                                                    <span class="h6"> This table shows all payments with
                                                                        due
                                                                        amounts (unmatched)
                                                                        on account. Enter the SL A/C to filter by
                                                                        account.
                                                                    </span></b-col></b-row>
                                                        </b-alert></b-col>
                                                </b-row>
                                                <b-row class="">
                                                    <b-col cols="12" sm="6" md="4" xl="3">
                                                        <b-form-group label-cols="12" label="Client SL A/C"
                                                            label-size="sm">
                                                            <treeselect placeholder="Select slac..."
                                                                searchPromptText="Type at least 3 chars..."
                                                                v-model="slac" :clearable="true" :multiple="true"
                                                                :async="true" :load-options="treeselect_loadSLAC"
                                                                :show-count="true" :flatten-search-results="true"
                                                                :disable-branch-nodes="true" :matchKeys="['id']"
                                                                search-nested>
                                                                <div slot="value-label" slot-scope="{ node }">
                                                                    {{ node.raw.id }}
                                                                </div>
                                                            </treeselect>
                                                        </b-form-group>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col>
                                                        <d-table classdivtable="availtable datatable" refid="matches"
                                                            :icon="payments.icon" :busy="payments.busy"
                                                            :tools="payments.tools" :badges="payments.badges"
                                                            :fields="payments.fields" :selectall="payments.selectall"
                                                            :items="payments.items" :page="payments.page"
                                                            :downloaded="payments.downloaded" :showpages="false"
                                                            @load="payments_load" @click="payments_click"
                                                            @select="payments_select">
                                                        </d-table>
                                                        <!-- <div v-if="component">
                                                                <component :is="component"
                                                                    :selection="payments.selected" :config="cconfig"
                                                                    @discard="payments_click('discard')"
                                                                    @refresh="payments_click('refresh')">
                                                                </component>
                                                            </div> -->
                                                    </b-col>
                                                </b-row>
                                            </b-tab>
                                        </b-tabs>
                                    </b-col>
                                </b-row>
                            </p>
                        </b-overlay>

                    </b-card-body>
                </b-card>
            </div>

            <b-card-footer class="mx-2 nopadding mt-2">
                <b-row no-gutters>
                    <b-col cols="auto" class="text-left">
                        <!-- :disabled="!(parseFloat(item.amount) == parseFloat(invoiceno_due))" -->
                        <b-button v-if="payindex == 0" squared size="sm" variant="primary"
                            :disabled="postit_disabled || (parseFloat(this.difference) != 0 || parseFloat(this.amount) == 0)"
                            @click="save_it">
                            <i class="fa fa-check pr-1"></i>
                            Post It
                        </b-button>
                    </b-col>
                    <b-col class="text-left ml-2 mt-1">
                        <div v-if="busy">
                            <i class="fa fa-spinner fa-spin text-primary"></i>
                        </div>
                        <div v-else>
                            <span v-html="message"></span>
                        </div>
                    </b-col>
                    <b-col class="text-right">
                        <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
                            <i class="fa fa-chevron-left pr-1"></i>Back
                        </b-button>
                    </b-col>
                </b-row>
            </b-card-footer>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";
import { v4 as uuidv4 } from 'uuid';

export default {
    name: "SLPayment",
    async mounted() {
        try {
            const response = await this.$apollo.query({
                query: gql`
                    query nlcodes {
                    nlcodes {
                        id
                        label
                    }
                    }
                `,
            });
            this.nlcode_options = response.data.nlcodes;
        } catch (error) {
            console.log(error);
        }
    },
    data() {
        return {
            payindex: 0,
            summary: "",
            message: "",
            busy: false,
            readonly: false,
            postit_disabled: false,
            popoverStatement: false,
            popoverMatch: false,
            matchesShow: false,
            load_busy: false,
            edited: false,
            amount: "",
            prefix: "PP",
            prefix_options: [
                {
                    id: "PP",
                    label: "PP",
                },
                {
                    id: "PC",
                    label: "PC",
                },
                {
                    id: "PA",
                    label: "PA",
                },
            ],
            page: 1,
            amount: 0,
            slac: [],
            spentorreceived: 'spent',
            data: null,
            bankingslines: [],
            banking_options: [],
            nlcode_options: [],
            vat_options: [],
            columns: ['prefix', 'description', 'slac', 'eventcode', 'nlcode', 'amount'],
            lines: [],
            selectedComponent: null,
            search: {
                //event: null,
            },
            payments: {
                icon: "fa fa-wpforms text-primary",
                debounce: 500,
                busy: false,
                selectall: false,
                tools: "go,download,clipboard,deleteconfirm",
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px text-primary",
                    },
                    {
                        key: "date",
                        label: "Date",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                        formatter: (value, key, item) => {
                            let result = "";
                            if (value) {
                                result = this.$moment
                                    .unix(value / 1000).utc(true)
                                    .format("DD/MM/YYYY HH:mm");
                            }
                            return result;
                        },
                    },
                    {
                        key: "ref",
                        label: "Ref",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "slac",
                        label: "SL A/C",
                        sortable: true,
                        class: "d-none d-sm-table-cell",
                    },
                    {
                        key: "linetype",
                        label: "Line",
                        sortable: true,
                        class: "text-right",
                    },
                    {
                        key: "valueuncleared",
                        label: "Amount",
                        sortable: true,
                        class: "text-right",
                        total: 0,
                        totalled: true,
                    },
                    // {
                    //     key: "due",
                    //     label: "Due",
                    //     sortable: true,
                    //     class: "text-right",
                    //     total: 0,
                    //     totalled: true,
                    // },
                    // {
                    //     key: "cleared",
                    //     label: "Cleared?",
                    //     sortable: true,
                    //     class: "text-right",
                    // },
                ],
                badges: [],
                item: {},
                items: [],
                selected: [],
                downloaded: [],
            },
        };
    },
    props: {
        value: { type: Object, required: true },
        title: { type: String, default: "" },
    },
    computed: {
        difference() {
            let value = 0
            if (this.amount && this.lines.length >= 1) {
                value = Math.abs(parseFloat(this.amount)) - this.lines.filter(item => item.amount && item.prefix != 'PA').reduce((sum, item) => (sum + Math.abs(parseFloat(item.amount))), 0)
            }
            return Math.abs(value).toFixed(2)
        }
    },
    watch: {
        value: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    this.lines = newVal.items
                    this.edited = false
                }
            }
        },
        amount: {
            immediate: true,
            async handler(newVal, oldVal) {
                if (parseFloat(newVal)) {
                    console.log('amount', newVal)
                    this.lines[0].amount = parseFloat(newVal)
                }
            }
        },
    },
    methods: {
        async save_it() {
            console.log('save_it', this.payindex)

            this.busy = true

            let variables = {}
            let signofvalue = -1

            variables.rows = JSON.parse(JSON.stringify(this.lines.filter(o => o.amount)))

            // ENSURE CORRECT SIGN FROM STATEMENT LINE IS SENT THROUGH
            for (var j = 0; j < variables.rows.length; ++j) {
                variables.rows[j].amount = parseFloat(variables.rows[j].amount * signofvalue).toFixed(2)
            }
            variables.rows = variables.rows.map(obj => ({ ...obj, bankinglines_id: uuidv4() }))
            variables.rows = variables.rows.map(obj => ({ ...obj, date_at: this.$moment().utc(true).format('YYYY-MM-DD') + " " + this.$moment().format('HH:mm') }))

            console.log(variables)
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                                mutation SL_payments_onaccount_save(
                                    $rows: [SL_payments_onaccount_input]    
                                    $referenceno:String
                                    $allocateonly:Boolean      
                                ) {
                                    SL_payments_onaccount_save(rows:$rows,referenceno:$referenceno,allocateonly:$allocateonly) {
                                         id
                                        type
                                        bankinglines_id
                                        link_id
                                        link_type      
                                        who
                                        what
                                        why
                                        vat
                                        ref
                                        transfer
                                        fee
                                        adjust
                                        link
                                        deleted
                                        dicuss
                                        date_at
                                        amount
                                        difference
                                        created_at
                                        updated_at
                                        created_by
                                        updated_by                            
                                    }
                                }
                                `,
                    variables,
                });

                let reconciled = response.data.SL_payments_onaccount_save[0]
                this.message = "<span class='text-primary'>Saved it. " + reconciled.ref + "</span>";

                this.postit_disabled = true

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message.split('GraphQL error: ').join('') + "</span>";
                this.postit_disabled = false
            }

            this.busy = false
        },
        async payments_load(offset, limit, page) {

            let state = this.payments;

            if (page) {
                state.page = page
            }

            this.payments.busy = true;

            let variables = {
                slac: this.slac.length > 0 ? this.slac.join(',') : null,
                linetype: "H",
                query: "due"
            };
            console.log("variables", variables);
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query SLPayments($slac: String, $linetype: String, $query: String) {
                            SLPayments(slac: $slac, linetype: $linetype, query: $query) {
                                id
                                date
                                slac
                                ref
                                linetype
                                valueuncleared
                            }
                        }
                    `,
                    variables,
                });

                // state.items = response.data.SLPayments;

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.SLPayments
                } else {
                    state.items = response.data.SLPayments;
                }

            } catch (error) {
                console.log(error);
            }

            this.payments.busy = false;
        },
        async payments_click(a, ss) {
            console.log("matches_click", a, ss);

            let state = this.payments;

            switch (a) {
                case "selectall":
                    this.payments.selectall = !this.payments.selectall;
                    break;

                            case "download_view":
          state.downloaded = []
          state.downloaded = this.state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.payments_load(0, 0);
          break;


                case "go":
                    this.component = null;
                    await this.payments_load();
                    break;
                case "delete":
                    if (ss.length > 0) {
                        await this.payments_deleteit(ss);
                    }
                    break;
            }
        },
        async payments_select(ss, tools) {
            console.log("payments_select", ss);

            let state = this.payments;

            state.selected = ss;
            let tool = null;

            if (tools) {
                let enabled = ["back", "go", "filter", "add", "export", "clipboard","download"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit", "notes"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                enabled = ["save", "deleteconfirm"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length > 0 ? false : true;
                    }
                });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }

            // if (state.selected.length > 0) {
            //     state.item = { ...state.selected[0] }  // WHAT YOU SELECTED
            //     state.item.datetravel = this.$moment.unix(state.item.datetravel * 0.001).utc(true).format("YYYY-MM-DD")
            //     state.item.ticketno = state.item.ticketno.split(',')
            // } else {
            //     state.item = {}
            // }
        },
        async payments_deleteit(ss) {
            console.log("deleteit", ss);

            let rows = [];
            ss.forEach(function (v) {
                rows.push({ id: v.id });
            });

            let variables = {
                rows,
            };

            console.log(variables);
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                        mutation SLPayments_delete($rows: [SLPayment_input]) {
                        SLPayments_delete(rows: $rows) {
                            id
                        }
                        }
                    `,
                    variables,
                });
            } catch (error) {
                console.log(error);
            }

            await this.payments_load();

        },
        addLine() {
            let _copy = {}
            switch (this.payindex) {
                case 0:
                    _copy = { ...this.lines[this.lines.length - 1] }
                    _copy.prefix = this.lines[this.lines.length - 1].prefix
                    _copy.description = this.lines[this.lines.length - 1].description
                    _copy.slac = this.lines[this.lines.length - 1].slac
                    _copy.eventcode = this.lines[this.lines.length - 1].eventcode
                    _copy.nlcode = "1100"
                    _copy.amount = this.lines[this.lines.length - 1].amount
                    this.lines.push(_copy)
                    break;
                case 1:
                    _copy = { ...this.bl_lines[this.bl_lines.length - 1] }
                    _copy.prefix = this.bl_lines[this.bl_lines.length - 1].prefix
                    _copy.description = this.bl_lines[this.bl_lines.length - 1].description
                    _copy.blac = this.bl_lines[this.bl_lines.length - 1].blac
                    _copy.eventcode = this.bl_lines[this.bl_lines.length - 1].eventcode
                    _copy.nlcode = "1200"
                    _copy.amount = this.bl_lines[this.bl_lines.length - 1].amount
                    this.bl_lines.push(_copy)
                    break;
            }
            this.edited = true
        },
        delLine(index) {
            switch (this.payindex) {
                case 0:
                    this.lines.splice(index - 1, 1)
                    break;
                case 1:
                    this.bl_lines.splice(index - 1, 1)
                    break;
            }
            this.edited = true
        },
        onClose() {
            this.popoverStatement = false
            this.popoverMatch = false
        },
        onShow() {
            // This is called just before the popover is shown
            // Reset our popover form variables
            // this.input1 = ''
            // this.input2 = ''
            // this.input1state = null
            // this.input2state = null
            // this.input1Return = ''
            // this.input2Return = ''
        },
        onShown() {
            // Called just after the popover has been shown
            // Transfer focus to the first input
            // this.focusRef(this.$refs.input1)
        },
        onHidden() {
            // Called just after the popover has finished hiding
            // Bring focus back to the button
            // this.focusRef(this.$refs.button)
        },
        focusRef(ref) {
            // Some references may be a component, functional component, or plain element
            // This handles that check before focusing, assuming a `focus()` method exists
            // We do this in a double `$nextTick()` to ensure components have
            // updated & popover positioned first
            this.$nextTick(() => {
                this.$nextTick(() => {
                    ; (ref.$el || ref).focus()
                })
            })
        }
    }
};
</script>